// 1 Muharram 1446 AH = 2024-07-07
const REF_GREG = new Date('2024-07-07').getTime();
const REF_HIJRI_YEAR = 1446;
const HIJRI_YEAR_DAYS = 354.367;
const HIJRI_MONTH_DAYS = 29.53;

/**
 * Rough Hijri year/month for "today", independent of any single country's
 * confirmation status. Used to pick a sensible default target month (Initialize)
 * and to check whether a country's confirmations have kept pace with the calendar
 * (dashboard card status).
 */
export function getApproximateHijriToday(): { year: number; month: { index: number } } {
  const daysSinceRef = (Date.now() - REF_GREG) / 86400000;
  const year = REF_HIJRI_YEAR + Math.floor(daysSinceRef / HIJRI_YEAR_DAYS);
  const remaining = daysSinceRef % HIJRI_YEAR_DAYS;
  const index = Math.min(12, Math.max(1, Math.floor(remaining / HIJRI_MONTH_DAYS) + 1));
  return { year, month: { index } };
}
